export default __webpack_public_path__ + "static/media/temp stay E6 - Commitments pursuant to international agreements or conventions.7a824750.jpg";